/**
 * 获取account_key
 * Create by liaokai on 2020-04-03 11:26:53
 */
import {toPost} from "../http-utils";

export const getAccountKey = toPost<
    {
       
    },
    {
      account_key:string
    }
    >("/merchant/merchant/getAccountKey");
